<template>
  <v-container fluid>
    <validation-observer ref="observer" v-slot="{ invalid }">
      <v-row justify="center">
        <v-col cols="12">
          <base-material-card color="primary" icon="mdi-file-compare" inline class="px-5 py-5">
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">Adicionar Novo Cálculo</div>
            </template>
            <v-form class="pt-5">
              <v-row align="center" no-gutters class="mx-4">
                <v-col cols="12">
                  <info />
                </v-col>
                <v-col cols="12">
                  <validation-provider id="nome-kpis-aderencias-bdgd" v-slot="{ errors }" rules="required">
                    <v-text-field v-model="nome" label="Título" outlined :error-messages="errors" />
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row align="center" no-gutters class="mx-4">
                <v-col cols="12">
                  <validation-provider id="ano-kpis-aderencias-bdgd" v-slot="{ errors }" rules="required">
                    <v-select v-model="ano" no-gutters outlined :items="anosList" label="Ano" :error-messages="errors" />
                  </validation-provider>
                </v-col>
              </v-row>
            </v-form>
          </base-material-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn
            id="btn-save-kpis-aderencias-bdgd"
            color="green"
            min-width="100"
            style="float: right"
            :disabled="invalid"
            :loading="loading"
            @click="salvarCalculo()"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>
  import KpisAderenciasBdgdService from '@/services/KpisAderenciasBdgdService';
  import tourMixins from '@/mixins/tourMixins';

  export default {
    name: 'KpisAderenciasBdgdAdd',

    components: {
      Info: () => import('@/components/kpisAderenciasBdgd/Info.vue')
    },

    mixins: [tourMixins],

    data() {
      return {
        loading: false,
        nome: '',
        anosList: [],
        arrTour: [
          {
            element: '#info-kpis-aderencias-bdgd',
            intro:
              'Para que a ferramenta funcione corretamente, alguns dados precisam ser importados no Hexa. Aqui estão listadas as dependências da ferramenta. Caso tenha dúvidas de como inseri-las, por favor, entre em contato com a equipe de suporte do Hexa.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#nome-kpis-aderencias-bdgd',
            intro: 'Aqui você deve nomear o seu cálculo. Escolha um nome bem descritivo.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#ano-kpis-aderencias-bdgd',
            intro: 'Aqui você deverá informar o ano para o cálculo.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#btn-save-kpis-aderencias-bdgd',
            intro:
              'Após seleção dos critérios anteriores, clique aqui para salvar e executar seu cálculo de KPIs de Aderências de BDGD.',
            scrollTo: 'tooltip',
            position: 'right'
          }
        ],
        ano: undefined
      };
    },
    mounted() {
      this.getAnosList();
    },
    methods: {
      getAnosList() {
        const anoAtual = new Date().getFullYear();
        KpisAderenciasBdgdService.getAnos()
          .then((res) => {
            let anos = [];
            if (res.data.anos) {
              anos = res.data.anos.map(({ ano }) => ano);
            }
            if (!anos.length) {
              anos.push(anoAtual);
              this.ano = anoAtual;
            }
            this.anosList = anos;
          })
          .catch((err) => {
            this.anosList = [anoAtual];
            console.error(err);
          })
          .finally(() => this.iniciarTourPagina());
      },
      salvarCalculo() {
        this.loading = true;
        const data = {
          nome: this.nome,
          ano: this.ano
        };
        KpisAderenciasBdgdService.salvar(data)
          .then(() => {
            this.$router.push('historico');
            this.$toast.success('KPIs Aderências BDGD salva com sucesso.', '', {
              position: 'topRight'
            });
          })
          .catch((err) => {
            console.log('Erro: ', err);
            this.$toast.error('Erro ao salvar o cálculo.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      },
      iniciarTourPagina() {
        if (this.tourFuncCalled) return;
        this.iniciarTour(this.arrTour);
      }
    }
  };
</script>
